let app;
function set_app(value) {
  app = value;
}
export {
  app as a,
  set_app as s
};
